
export default {
  props: {
    value: {
      type: null,
      required: true,
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    name: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'text',
    },

    placeholder: {
      type: String,
      default: '',
    },

    validationMode: {
      type: String,
      default: 'lazy',
    },

    autocomplete: {
      type: String,
      default: null,
    },

    height: {
      type: Number,
      default: 2.875,
    },
  },

  data() {
    return {
      innerValue: '',
      showBtn: false,
    }
  },

  computed: {
    inputHeight() {
      return {
        '--height': this.height + 'rem',
      }
    },
  },

  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
    },

    value(newVal) {
      this.innerValue = newVal
    },
  },

  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
